export const GET_FORYOU_PRODUCTS_REQUEST = "GET_FORYOU_PRODUCTS_REQUEST";
export const GET_FORYOU_PRODUCTS_SUCCESS = "GET_FORYOU_PRODUCTS_SUCCESS";
export const GET_FORYOU_PRODUCTS_FAIL = "GET_FORYOU_PRODUCTS_FAIL";
